export default "__VITE_ASSET__BwBQtXGN__"